export default "__VITE_ASSET__DmkDJ7pN__"